import { Routes, Route } from "react-router-dom";
import { AppShell } from "./components/layout/AppShell";
import { BoxApprovalsPage } from "./pages/BoxApprovalsPage";
import { DependenciesPage } from "./pages/DependenciesPage";
import { LogsPage } from "./pages/LogsPage";
import { LogJobDetailPage } from "./pages/LogJobDetailPage";
import { UsagePage } from "./pages/UsagePage";
import { FleetPage } from "./pages/FleetPage";
import { FleetFlowPage } from "./pages/FleetFlowPage";
import { NatsPage } from "./pages/NatsPage";
import { RegistryPage } from "./pages/RegistryPage";
import { WorkerLogsPage } from "./pages/WorkerLogsPage";
import { Toaster } from "./components/ui/toast";

export function App() {
  return (
    <>
      <Routes>
        <Route element={<AppShell />}>
          <Route path="/" element={<BoxApprovalsPage />} />
          <Route path="/dependencies" element={<DependenciesPage />} />
          <Route path="/logs" element={<LogsPage />} />
          <Route path="/logs/:id" element={<LogJobDetailPage />} />
          <Route path="/usage" element={<UsagePage />} />
          <Route path="/fleet" element={<FleetPage />} />
          <Route path="/fleet/flow" element={<FleetFlowPage />} />
          <Route path="/fleet/nats" element={<NatsPage />} />
          <Route path="/registry" element={<RegistryPage />} />
          <Route path="/worker-logs" element={<WorkerLogsPage />} />
        </Route>
      </Routes>
      <Toaster />
    </>
  );
}
